import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiResponse } from '../models/api-response.model';
import { NotificacionTipoReceptorDto } from '../models/notificacion-tipo-receptor.model';
import { AuthService } from './auth.service';
import { BaseApiService } from './api-base.service';
import { ConfigService } from './config.service';
import { ConfigClientService } from './configClient.service';
import { SINERGIAL_ROUTES } from '../constants/api-sinergial-routes';

const DEFAULT_PARAMS = {
  orden: 2,
  SentidoOrden: 'asc',
  pageNumber: -1,
} as const;

@Injectable({ providedIn: 'root' })
export class NotificacionTipoReceptorService extends BaseApiService<
  ApiResponse<NotificacionTipoReceptorDto[]>
> {
  constructor(
    http: HttpClient,
    configService: ConfigService,
    authService: AuthService,
    configClientService: ConfigClientService,
  ) {
    super(http, configService, configClientService, authService);
  }

  getTiposReceptor(
    extra?: Record<string, string | number | boolean>,
  ): Observable<ApiResponse<NotificacionTipoReceptorDto[]>> {
    return this.get<ApiResponse<NotificacionTipoReceptorDto[]>>(SINERGIAL_ROUTES.NOTIFICACION_TIPO_RECEPTOR.PATH_BASE, {
      params: { ...DEFAULT_PARAMS, ...extra },
    });
  }
}
